import DealersIntegral from './dealers_integral.vue';

export default DealersIntegral;
